import { cn } from "@dalmatech/ui"

const root = cn("")
const container = (
  isWelcomePage: boolean,
  isPricingPage: boolean,
  isBannerDisplayed?: boolean,
  isRedirectIntoPrepackage?: boolean,
  isAttributionQuestion?: boolean,
  isPrepackage?: boolean,
  isRecap?: boolean,
  isHealthPage?: boolean,
  isTribe?: boolean
) =>
  cn(
    "px-4 md:py-16 pt-[7rem] md:pt-[6.75rem] lg:pt-[7rem] md:pb-32 box-border",
    isRedirectIntoPrepackage ? "px-4 pb-0 md:pb-0" : "",
    isAttributionQuestion ? "pb-[12rem] md:py-16 md:pb-[12rem]" : "",
    isBannerDisplayed
      ? "pt-[14rem] md:pt-[13rem] sm:pt-[10.75rem] lg:pt-[10rem]"
      : isPricingPage
      ? "pt-0 lg:pt-0 sm:pt-0 px-0 md:pb-16"
      : isWelcomePage
      ? "pt-4 lg:pt-16 px-4"
      : "",
    isPrepackage ? "pb-[14rem] md:pb-[14rem]" : "",
    isHealthPage ? "pb-[12rem] md:py-16" : "",
    isPricingPage ? "pb-[14rem] md:py-16" : "",
    isRecap ? "pb-[12rem] md:py-16 md:pb-[12rem]" : "",
    isTribe ? "pb-[12rem]  md:py-16" : ""
  )
const scroller = cn("relative")
export { container, root, scroller }
